import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Box } from '@mui/material';
import { Newspaper as NewspaperIcon, Refresh as RefreshIcon } from '@mui/icons-material';

const ArticleListPageAlerts = ({
  pendingPrintsCount,
  isMobile,
  hasNewArticles,
  theme,
  onOpenPendingPrints,
  onRefreshArticles
}) => (
  <>
    {pendingPrintsCount > 0 && (
      <Alert
        severity="info"
        icon={<NewspaperIcon />}
        sx={{
          mx: isMobile ? 2 : 3,
          mb: 2,
          mt: 2,
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
          transition: 'transform 0.2s',
          '&:hover': { transform: 'scale(1.005)' }
        }}
        onClick={onOpenPendingPrints}
      >
        Você tem <strong>{pendingPrintsCount} recortes impressos</strong> (Jornais/Revistas) aguardando a finalização do cadastro. <strong>Clique aqui para resolver.</strong>
      </Alert>
    )}

    {hasNewArticles && (
      <Box sx={{
        position: 'fixed',
        top: { xs: 80, md: 100 },
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        zIndex: 1200,
        pointerEvents: 'none',
        animation: 'slideDownFade 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
      }}>
        <style>
          {`
            @keyframes slideDownFade {
              from { opacity: 0; transform: translateY(-30px); }
              to { opacity: 1; transform: translateY(0); }
            }
          `}
        </style>
        <Alert
          severity="info"
          icon={<RefreshIcon />}
          sx={{
            pointerEvents: 'auto',
            cursor: 'pointer',
            borderRadius: '30px',
            px: { xs: 2, md: 4 },
            py: 0.5,
            alignItems: 'center',
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.mode === 'dark' ? '#29b6f6' : '#0277bd',
            border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(41, 182, 246, 0.3)' : '#b3e5fc'}`,
            backdropFilter: 'none',
            WebkitBackdropFilter: 'none',
            boxShadow: theme.palette.mode === 'dark' ? '0 10px 24px rgba(0,0,0,0.34)' : '0 10px 24px rgba(15,23,42,0.12)',
            transition: 'background-color 0.18s ease, box-shadow 0.18s ease',
            '& .MuiAlert-icon': {
              color: theme.palette.mode === 'dark' ? '#29b6f6' : '#0277bd'
            },
            '&:hover': {
              boxShadow: theme.palette.mode === 'dark' ? '0 12px 36px rgba(41, 182, 246, 0.15)' : '0 12px 36px rgba(2, 119, 189, 0.15)'
            }
          }}
          onClick={onRefreshArticles}
        >
          Novos artigos chegaram. <strong>Clique para recarregar a lista.</strong>
        </Alert>
      </Box>
    )}
  </>
);

ArticleListPageAlerts.propTypes = {
  pendingPrintsCount: PropTypes.number.isRequired,
  isMobile: PropTypes.bool.isRequired,
  hasNewArticles: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  onOpenPendingPrints: PropTypes.func.isRequired,
  onRefreshArticles: PropTypes.func.isRequired
};

export default ArticleListPageAlerts;
